import { Button, Collapse, Modal, Popover, Row, Col } from 'antd';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ServerAPI } from '../../common/ServerAPI';
import { IMAGE_BASE_URL } from '../../common/Constants';
import axios from '../../axios/axios';
import { toast } from 'react-toastify';
import DisbursementDoc from './DisbursementDoc';
import dayjs from 'dayjs';
import { CaseDataContext } from './CaseDetails';
import { ReactComponent as View } from '../../images/view.svg';

const LoanCaseData = ({
  mainDisInfo,
  dataRows,
  icon,
  title,
  reloadData,
  comp,
  pagePermission,
  ID,
  disbursementForm,
  setDisbursementForm
}) => {
  const { setDocumentPreview, setDocumentUrl, fileType } = comp;
  const { activeTab } = useContext(CaseDataContext);
  const navigate = useNavigate();
  const { Panel } = Collapse;
  const [selfAA, setSelfAA] = useState(false);
  const [disbModal, setDisbModal] = useState(false);
  const [cModal, setCModal] = useState(false);
  const [applProdId, setApplProdId] = useState('');

  const [disbViewMode, setDisbViewMode] = useState(false);
  const [dataDocuments, setDataDocuments] = useState([]);
  const previewForm = async (product_id) => {
    const response = await ServerAPI.previewLoanApplicantion(product_id);
  };

  const acceptCounterOffer = async () => {
    const tokenId = localStorage.getItem('dealerModuleToken');
    const resp = await axios.put(
      `accept/counter/offer/${applProdId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenId}`,
        },
      }
    );
    if (resp) {
      toast.success('Counter Offer Accepted!!');
      setCModal(false);
      reloadData();
    }
  };
  const submitDisbursement = async (applData) => {
    const docData = JSON.parse(localStorage.getItem('disbursementDocuments'));
    const applicationId = localStorage.getItem('applicationId');
    const tokenId = localStorage.getItem('dealerModuleToken');
    if (docData) {
      const disDocLen = Object.keys(docData).length;
      if (disDocLen < 4) {
        toast.error('Please upload mandatory documents');
      } else {
        const applProdId = applData.applProdId;
        const remarks = applData?.remarks ? applData?.remarks : '';
        const disbursement_date = applData?.disbursement_date
          ? applData?.disbursement_date
          : '';
        const resp = await axios.post(
          `/loan/application/disbursement/${applicationId}`,
          {
            ...docData,
            application_product: applProdId,
            remarks: remarks,
            disbursement_date: disbursement_date,
          },
          {
            headers: {
              Authorization: `Bearer ${tokenId}`,
            },
          }
        );
        if (resp) {
          toast.success('Disbursement Documents Updated Successfully!!');
          setDisbursementForm([]);
          reloadData();
          setDisbViewMode(true);
        }
      }
    } else {
      toast.error('Please upload your documents');
    }
  };
  const revertDisburseDoc = async (disbId) => {
    const tokenId = localStorage.getItem('dealerModuleToken');
    setDisbursementForm([]);
    localStorage.removeItem('disbursementDocuments');
    const resp = await axios.delete(`remove/disbursement/${disbId}`, {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    });
    if (resp) {
      reloadData();
      toast.success('Disbursement Documents Reverted Successfully!!');
      setDisbViewMode(false);
    }
  };
  useEffect(() => {
    if (mainDisInfo === null || mainDisInfo === '') {
      setDisbViewMode(false);
    } else {
      setDisbViewMode(true);
      setDataDocuments([
        {
          transaction_history: mainDisInfo?.transaction_history,
        },
        {
          vehicle_information: mainDisInfo?.vehicle_information,
        },
        {
          vehicle_acknowledgement: mainDisInfo?.vehicle_acknowledgement,
        },
        {
          insurance_certificate: mainDisInfo?.insurance_certificate,
        },
        {
          number_retention_letter: mainDisInfo?.number_retention_letter,
        },
      ]);
    }
  }, [mainDisInfo]);
  return (
    <>
      <section>
        {dataRows.length > 0 &&
          dataRows.map((dataRow, index) => {
            const dealerCommPercentage =
              parseFloat(dataRow?.dealer_commission_percentage) || 0;
            const dealerCommAmount =
              parseFloat(dataRow?.dealer_commission_amount) || 0;
            const dealerCommFormatted = `${dealerCommPercentage.toFixed(
              2
            )}% ($${dealerCommAmount.toFixed(0)})`;

            const counterCommPercentage =
              parseFloat(dataRow?.counterData?.agentcommsion).toFixed(1) || '0';
            const counterCommAmount =
              (
                (dataRow?.counterData?.agentcommsion *
                  dataRow?.counterData?.loanamount) /
                100
              ).toFixed(0) || '0';
            const counterCommFormatted = `${counterCommPercentage}% ($${counterCommAmount})`;

            const isCountAccept = dataRow.is_counter_offer_accepted;

            return (
              <div className='accordion-section' key={dataRow.key}>
                <div className='loan-app-block'>
                  <div className='loan-app-list'>
                    <h2>Interest</h2>
                    <h3
                      className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                        }`}
                    >
                      {dataRow?.interest || 'N/A'}%
                    </h3>
                    {dataRow?.counterData && (
                      <h3
                        className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                          }`}
                      >
                        {dataRow?.counterData?.interest || 'N/A'}%
                      </h3>
                    )}
                  </div>
                  <div className='loan-app-list'>
                    <h2>Loan Amt.</h2>
                    <h3
                      className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                        }`}
                    >
                      ${dataRow?.loan_amt || 'N/A'}
                    </h3>
                    {dataRow?.counterData && (
                      <h3
                        className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                          }`}
                      >
                        $
                        {parseInt(dataRow?.counterData?.loanamount).toFixed(
                          0
                        ) || 'N/A'}
                      </h3>
                    )}
                  </div>
                  <div className='loan-app-list'>
                    <h2>Tenor (mths)</h2>
                    <h3
                      className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                        }`}
                    >
                      {dataRow?.tenor || 'N/A'}
                    </h3>
                    {dataRow?.counterData && (
                      <h3
                        className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                          }`}
                      >
                        {dataRow?.counterData?.tenure || 'N/A'}
                      </h3>
                    )}
                  </div>
                  <div className='loan-app-list'>
                    <h2>Dealer Commision</h2>
                    <h3
                      className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''
                        }`}
                    >
                      {dealerCommFormatted}
                    </h3>
                    {dataRow?.counterData && (
                      <h3
                        className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'
                          }`}
                      >
                        {counterCommFormatted}
                      </h3>
                    )}
                  </div>
                  <div className='loan-app-list'>
                    <h2>Admin Fee</h2>
                    <h3 className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''}`}>
                      ${Math.round(dataRow?.admin_fee || 0)}
                    </h3>
                    {dataRow?.counterData && (
                      <h3
                        className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'}`}
                      >
                        ${Math.round(dataRow?.counterData?.admin_fee || 0)}
                      </h3>
                    )}
                  </div>
                  <div className='loan-app-list'>
                    <h2>Mthly. Installment</h2>
                    <h3 className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''}`}>
                      ${Math.ceil(dataRow?.mnthly_installement || 0)}
                    </h3>
                    {dataRow?.counterData && (
                      <h3
                        className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'}`}
                      >
                        ${Math.ceil(dataRow?.counterData?.monthly_installment || 0)}
                      </h3>
                    )}
                  </div>
                  <div className='loan-app-list'>
                    <h2>Last Installment</h2>
                    <h3 className={`${dataRow?.counterData != null ? 'text-[#d62433]' : ''}`}>
                      ${Math.ceil(dataRow?.last_installment || 0)}
                    </h3>
                    {dataRow?.counterData && (
                      <h3
                        className={`${isCountAccept ? 'text-[#00AE11]' : 'text-[#ED7A15]'}`}
                      >
                        ${Math.ceil(dataRow?.counterData?.last_installment || 0)}
                      </h3>
                    )}
                  </div>
                </div>
                {dataRow.product_dis_info &&
                  dataRow.product_dis_info.disbursement_date && (
                    <div className='disbursement-card-block'>
                      <h5>
                        Agent has made the disbursement. Please check funds in
                        your bank account:
                      </h5>
                      <div className='loan-app-block'>
                        <div className='loan-app-list'>
                          <h2>Date of Disbursement</h2>
                          <h3>
                            {dataRow.product_dis_info.disbursement_date
                              ? dayjs(
                                dataRow.product_dis_info.disbursement_date
                              ).format('DD-MM-YYYY')
                              : 'N/A'}
                          </h3>
                        </div>
                        <div className='loan-app-list'>
                          <h2>Disbursement Proof</h2>
                          {dataRow?.product_dis_info ? (
                            dataRow?.product_dis_info
                              ?.agent_disbursement_ack_doc.length > 0 ? (
                              <Fragment>
                                {dataRow?.product_dis_info
                                  .agent_disbursement_ack_doc !== undefined &&
                                  dataRow?.product_dis_info.agent_disbursement_ack_doc.map(
                                    (doc, index) => {
                                      let valType = false;
                                      let imgType = '';
                                      if (typeof doc === 'object') {
                                        valType = true;
                                        let popType = '';
                                        if (doc?.name?.includes('.pdf')) {
                                          imgType = 'pdf';
                                        } else if (doc?.name?.includes('.docx')) {
                                          imgType = 'docx';
                                        }
                                      }
                                      return (
                                        <>
                                          <div>
                                            <Fragment>
                                              <div className='sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2'>
                                                {imgType === 'pdf' ? (
                                                  <FilePdfOutlined className='pdfOutlineStyle' />
                                                ) : imgType === 'docx' ? (
                                                  <FileWordOutlined className='pdfOutlineStyle' />
                                                ) : (
                                                  <img
                                                    style={{
                                                      width: '50px',
                                                      height: '50px',
                                                    }}
                                                    className='mr-3 mt-[2px]'
                                                    alt='doc'
                                                    src={
                                                      valType
                                                        ? IMAGE_BASE_URL +
                                                        doc.value
                                                        : IMAGE_BASE_URL + doc
                                                    }
                                                  />
                                                )}
                                                <div className='w-full flex justify-between mt-4'>
                                                  <div className='text-[13px] font-[500] text-[#0D062D] whitespace-nowrap truncate max-w-[180px]'>
                                                    {valType
                                                      ? doc.name
                                                      : doc.split('/').pop()}
                                                  </div>
                                                  <div>
                                                    <div className='text-right'>
                                                      <img
                                                        src='/images/document_download.png'
                                                        alt='Download Document'
                                                        className='max-w-xs cursor-pointer ml-auto'
                                                        onClick={() => {
                                                          setDocumentPreview(
                                                            true
                                                          );
                                                          setDocumentUrl(
                                                            valType
                                                              ? doc.value
                                                              : doc
                                                          );
                                                          fileType(
                                                            valType
                                                              ? doc.value
                                                              : doc
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className='w-full flex justify-between items-center mt-1'>
                                                <p className='text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1'></p>
                                              </div>
                                            </Fragment>
                                          </div>
                                        </>
                                      );
                                    }
                                  )}
                              </Fragment>
                            ) : (
                              <h3>N/A</h3>
                            )
                          ) : (
                            <h3>N/A</h3>
                          )}
                        </div>
                        <div className='loan-app-list'>
                          <h2>Remarks</h2>
                          <h3>{dataRow?.product_dis_info.remarks || 'N/A'}</h3>
                        </div>
                      </div>
                    </div>
                  )}
                <div className='loan-footer-block'>
                  <div className='loan-footer-list'>
                    <Button
                      className='sav_btn'
                      onClick={() => {
                        navigate('/view-application', {
                          state: {
                            productId: dataRow?.application_product,
                          },
                        });
                      }}
                    >
                      <span>
                        <View />
                      </span>
                      View Application Form
                    </Button>

                    <>
                      {dataRow.application_product_status ===
                        'counter_offered' && (
                          <>
                            {pagePermission?.update_permission == 1 && (
                              <Button
                                type='primary'
                                className={`${!isCountAccept
                                  ? 'bg-[#055FFB!important]'
                                  : 'bg-[#27AE60!important]'
                                  } font-[500] min-w-[165px] min-h-[30px] cursor-pointer`}
                                onClick={() => {
                                  if (!isCountAccept) {
                                    setCModal(true);
                                    setApplProdId(dataRow.application_product);
                                  }
                                }}
                              >
                                {isCountAccept
                                  ? 'Accepted'
                                  : 'Accept Counter Offer'}
                              </Button>
                            )}
                          </>
                        )}
                    </>
                    {dataRow?.status &&
                      dataRow?.status?.instant_aa === false &&
                      dataRow?.app_provid_name === 'In-House' ? (
                      <span className='font-[600]'>Issue AA later</span>
                    ) : dataRow?.aa_files && dataRow?.aa_files.length > 0 ? (
                      dataRow?.aa_files.map((file, idx) => {
                        return (
                          <Button
                            className='sav_btn'
                            onClick={() => {
                              window.open(
                                IMAGE_BASE_URL + '/' + file.value,
                                '_blank'
                              );
                            }}
                          >
                            <span>
                              <View />
                            </span>
                            View AA
                          </Button>
                        );
                      })
                    ) : null}
                  </div>
                  <div className='loan-footer-list'>
                    {activeTab === '2' &&
                      (mainDisInfo === null || dataRow.product_dis_info) && (
                        <>
                          {dataRow.product_dis_info ? (
                            <Button
                              type='primary'
                              style={{
                                backgroundColor: "#27AE60"
                              }}
                              className={`bg-[#27AE60!important] font-[500] min-w-[165px] min-h-[30px]`}
                            >
                              Loan Product Selected
                            </Button>
                          ) : dataRow?.status?.instant_aa === true &&
                            pagePermission?.update_permission == 1 ? (
                            <Button
                              type='primary'
                              style={{
                                backgroundColor: disbursementForm?.includes(ID) ? "#27AE60" : ""
                              }}
                              className={`font-[500] min-w-[165px] min-h-[30px]`}
                              onClick={() => {
                                setDisbursementForm([ID])
                              }}
                            >
                              {disbursementForm?.includes(ID) ? "Selected" : "Select This Loan Product"}
                            </Button>
                          ) : null}
                          {(disbursementForm?.includes(ID) || dataRow.product_dis_info) &&
                            (dataRow?.product_dis_info === null ||
                              dataRow?.product_dis_info?.disbursement_date ===
                              null) &&
                            pagePermission?.update_permission == 1 && (
                              <Button
                                type='default'
                                className='font-[500] min-w-[71px] min-h-[32px] border-[#055FFB] text-[#055FFB]'
                                onClick={() => {
                                  setDisbModal(true);
                                }}
                              >
                                Cancel
                              </Button>
                            )}
                        </>
                      )}
                    {/* {activeTab === '2' &&
                      mainDisInfo !== null &&
                      dataRow.product_dis_info == null &&
                      pagePermission?.update_permission == 1 && (
                        <Button
                          type='primary'
                          disabled
                          className={`bg-[#055FFB!important] text-[white!important] opacity-[0.6] font-[500] min-w-[165px] min-h-[30px]`}
                        >
                          Select This Loan Product
                        </Button>
                      )} */}
                  </div>
                </div>
                <div className='disbursement-section'>
                  {activeTab === '2' &&
                    mainDisInfo !== null &&
                    dataRow.product_dis_info == null &&
                    pagePermission?.update_permission == 1 && (
                      <>
                        {mainDisInfo?.disbursement_date === null && (
                          <div className='mt-[8px] ml-[12px] text-[13px] font-[500] text-center lg:text-right'>
                            You've chosen a different loan product. If you'd
                            like to proceed with this loan option, please cancel
                            the previous one first.
                          </div>
                        )}
                      </>
                    )}
                  <Modal
                    title={'Undo Disbursement Documents'}
                    centered
                    open={
                      pagePermission?.update_permission == 1 ? disbModal : false
                    }
                    okText={'Confirm'}
                    onOk={() => {
                      if (dataRow.product_dis_info) {
                        revertDisburseDoc(dataRow.product_dis_info.id);
                      } else {
                        setDisbursementForm([]);
                        localStorage.removeItem('disbursementDocuments');
                      }
                      setDisbModal(false);
                    }}
                    onCancel={() => setDisbModal(false)}
                  >
                    Are you sure want to undo?
                  </Modal>
                  {/** */}
                  {activeTab === '2' && (
                    <>
                      {disbursementForm?.includes(ID) && (
                        <div className='disbursement-block'>
                          <div className='disbursement-header'>
                            <h4 className='text-[16px] font-[600]'>
                              Documents for Disbursement
                            </h4>
                            <div className='disbursement-head-btn'>
                              {!disbViewMode &&
                                pagePermission?.update_permission == 1 && (
                                  <>
                                    <Button
                                      type='default'
                                      className={` font-[500] min-w-[135px] bg-white min-h-[37px] mr-[20px]`}
                                      onClick={() => {
                                        setDisbViewMode(true);
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      type='primary'
                                      className={`bg-[#055FFB!important] font-[500] min-w-[135px] min-h-[35px]`}
                                      onClick={() => {
                                        if (dataRow.product_dis_info) {
                                          submitDisbursement({
                                            applProdId:
                                              dataRow.application_product,
                                            remarks:
                                              dataRow.product_dis_info.remarks,
                                            disbursement_date: dataRow
                                              .product_dis_info.disbursement_date
                                              ? dayjs(
                                                dataRow.product_dis_info
                                                  .disbursement_date
                                              ).format('YYYY-MM-DD')
                                              : '',
                                          });
                                        } else {
                                          submitDisbursement({
                                            applProdId:
                                              dataRow.application_product,
                                          });
                                        }
                                      }}
                                    >
                                      Submit to Agent
                                    </Button>
                                  </>
                                )}
                              {disbViewMode &&
                                dataRow?.product_dis_info?.disbursement_date ===
                                null &&
                                pagePermission?.update_permission == 1 && (
                                  <div className='text-end'>
                                    <Button
                                      type='primary'
                                      className={`bg-[#055FFB!important] font-[500] min-w-[135px] min-h-[35px]`}
                                      onClick={() => {
                                        setDisbViewMode(false);
                                      }}
                                    >
                                      Edit
                                    </Button>
                                  </div>
                                )}
                            </div>
                          </div>
                          {disbViewMode ? (
                            <Fragment>
                              <div className='disbursement-doc-section'>
                                {dataDocuments !== undefined &&
                                  dataDocuments.length > 0 &&
                                  dataDocuments.map((doc, index) => {
                                    const key = Object.keys(doc)[0];
                                    const valueLength = doc[key].length;
                                    let words = key.split('_');
                                    for (let i = 0; i < words.length; i++) {
                                      words[i] =
                                        words[i].charAt(0).toUpperCase() +
                                        words[i].slice(1);
                                    }
                                    let result = words.join(' ');
                                    if (result.length <= 4) {
                                      result = result.toUpperCase();
                                    }

                                    return (
                                      <div>
                                        <div className='sm:w-2/2 lg:w-4/4 mt-1 flex py-2 w-[250px] sm:w-[285px] max-w-full px-2'>
                                          <img
                                            style={{
                                              width: '15px',
                                              height: '15px',
                                            }}
                                            className='mr-3 mt-[2px]'
                                            src={
                                              '/images/' +
                                              'additional_documents' +
                                              '.png'
                                            }
                                          />
                                          <div className='w-full flex'>
                                            <div className='text-[13px] font-[500] text-[#0D062D]'>
                                              {result === 'NAO'
                                                ? 'NOA'
                                                : result ===
                                                  'Agent Disbursement Ack Doc'
                                                  ? 'Disbursement Document'
                                                  : result}
                                            </div>
                                          </div>
                                        </div>
                                        {doc[key].map((data) => {
                                          let valType = false;
                                          let imgType = '';
                                          if (typeof data === 'object') {
                                            valType = true;
                                            let popType = data.value
                                              .split('.')
                                              .pop();
                                            if (popType === 'pdf') {
                                              imgType = 'pdf';
                                            } else if (popType === 'docx') {
                                              imgType = 'docx';
                                            }
                                          }
                                          return (
                                            <Fragment>
                                              <div className='sm:w-2/2 lg:w-4/4 mt-1 flex border rounded bg-white py-2 w-full px-2'>
                                                {imgType === 'pdf' ? (
                                                  <FilePdfOutlined className='pdfOutlineStyle' />
                                                ) : imgType === 'docx' ? (
                                                  <FileWordOutlined className='pdfOutlineStyle' />
                                                ) : (
                                                  <img
                                                    style={{
                                                      width: '50px',
                                                      height: '50px',
                                                    }}
                                                    className='mr-3 mt-[2px]'
                                                    src={
                                                      valType
                                                        ? IMAGE_BASE_URL +
                                                        data.value
                                                        : IMAGE_BASE_URL + data
                                                    }
                                                  />
                                                )}
                                                <div className='w-full flex justify-between mt-4'>
                                                  <div className='text-[13px] font-[500] text-[#0D062D] sm:whitespace-nowrap sm:truncate sm:max-w-[180px]'>
                                                    {valType
                                                      ? data.name
                                                      : data.split('/').pop()}
                                                  </div>
                                                  <div>
                                                    <div className='text-right'>
                                                      <img
                                                        src='/images/document_download.png'
                                                        alt='Download Document'
                                                        className='max-w-xs cursor-pointer ml-auto'
                                                        onClick={() => {
                                                          setDocumentPreview(
                                                            true
                                                          );
                                                          setDocumentUrl(
                                                            valType
                                                              ? data.value
                                                              : data
                                                          );
                                                          fileType(
                                                            valType
                                                              ? data.value
                                                              : data
                                                          );
                                                          // DownloadDocumentFile();
                                                        }}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className='w-full flex justify-between items-center mt-1'>
                                                <p className='text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1'></p>
                                              </div>
                                            </Fragment>
                                          );
                                        })}
                                        <div></div>
                                      </div>
                                    );
                                  })}
                              </div>
                            </Fragment>
                          ) : (
                            <>
                              <p className='text-[13px] font-[500] mb-[20px]'>
                                Please upload the following documents for the
                                Agent to proceed to Disbursement
                              </p>
                              <DisbursementDoc
                                updateFunction={(val) => console.log(val)}
                              />
                            </>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            );
          })}
      </section>

      <Modal
        title={'Counter Offer'}
        okText={'Confirm'}
        cancelText={'Cancel'}
        open={pagePermission?.update_permission == 1 ? cModal : false}
        onOk={acceptCounterOffer}
        onCancel={() => setCModal(false)}
        centered
      >
        <p className='font-[500] text-[16px] mt-[15px] mb-[20px]'>
          Are you sure want to accept this counter offer?
        </p>
      </Modal>
    </>
  );
};

export default LoanCaseData;
